<template>
  <td  style="padding: 0 !important;">
    <div class="inCellHeight" v-if="rsi" :class="setColor()">
      {{ rsi.value }}
      (<i :class="setIcon()"/>)
    </div>
    <div class="inCellHeight" v-else>
      -
    </div>
  </td>
</template>

<script>
export default {
  name: "RSICell",
  props: ['rsi'],
  methods: {
    setIcon() {

      return this.rsi.trend === 'increasing' ? 'ri-arrow-right-up-line' : this.rsi.trend === 'decreasing' ? 'ri-arrow-right-down-line' : 'ri-pulse-line';
    },
    setColor() {

      const value = this.rsi.value;
      const dir = this.rsi.trend;

      if (dir === "increasing") {
        if (value < 30 || value > 50) {
          return "green";
        }
      }

      if (dir === "decreasing") {
        if (value > 70 || value < 50) {
          return "red";
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
td {
  padding: 0 !important;
}

div {
  padding: 7.5px 10px !important;
}
</style>
